import { createContext, useContext } from 'react'
import type { Me } from './identity'

/**
 * سياقُ الجلسة وحدَه — <b>بلا مكوّنٍ في هذا الملفّ</b>.
 *
 * الفصلُ مقصود: ملفٌّ يصدّر مكوّنًا ودالّةً معًا يُبطل تحديثَ التطوير السريع
 * (Fast Refresh)، فيُعاد تحميلُ الصفحة كاملةً مع كلّ تعديل — وتضيع الجلسةُ
 * والحالةُ في كلّ مرّة. والمزوّدُ في `AuthContext.tsx`.
 */

export type Session = {
  me: Me
  /** دخل بكلمةٍ مؤقّتة: لا طريقَ إلى الشاشات قبل تغييرها. */
  mustChangePassword: boolean
  /**
   * ⚠ **فاصل** (`0052`): الجلسةُ من نسخة الجهاز لا من الخادم — نقطةُ البيع تبيع
   * وتحفظ، وما يحتاج الخادمَ ينتظر. ولا تكون إلا في تطبيقٍ صُرّح له بذلك.
   */
  offline?: boolean
}

export type AuthState = {
  /** `undefined` = لم يُسأل الخادمُ بعد. `null` = لا جلسة. */
  session: Session | null | undefined
  login: (username: string, password: string) => Promise<void>
  logout: () => Promise<void>
  /** تُنادى بعد تغيير الكلمة بنجاح، فتسقط شاشةُ الإلزام. */
  passwordChanged: () => void
  refreshMe: () => Promise<void>
  can: (permission: string) => boolean
  /** خرج وحدَه بعد ساعتين بلا استخدام — شاشةُ الدخول تقول ذلك. */
  endedByIdle: boolean
}

export const AuthContext = createContext<AuthState | null>(null)

export function useAuth() {
  const context = useContext(AuthContext)

  if (!context) {
    throw new Error('useAuth خارج AuthProvider.')
  }

  return context
}
